<template>
	<div class="container">
		<!-- 菜单导航 -->
		<Menu></Menu>
		<div class="main-wrapper-content personal-center">
			<div class="breadcrumb_box">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/Personal' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>个人资料</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="personal-main">
				<div class="sticky">
					<el-tabs :tab-position="tabPosition" @tab-click="tabsClick">
						<el-tab-pane label="个人信息">
							<el-card>
								<el-form ref="form" :model="userList" label-width="80px" size="mini"
									label-position="left" :rules="rules">
									<el-form-item label="头像">
										<div>
											<img :src="userList.avatar_url" alt="" class="editor-material-img">
											<div class="avtouimg">
												<el-upload class="upload-demo" :show-file-list="false"
													action="/api/index/upload" :on-success="avrouSucess">
													<div class="imgavbox">
														<span class="iconfont icon-xiangji"></span>
														<p>上传头像</p>
													</div>
												</el-upload>
											</div>
										</div>
									</el-form-item>
									<el-form-item label="美课ID"> <span>{{ userList.id }}</span> </el-form-item>
									<el-form-item label="美课号">
										<span>{{ userList.account }}</span>
									</el-form-item>
									<el-form-item label="昵称" prop="nickname">
										<span>
											<el-input v-model="userList.nickname" style="width: 240px;"
												class="user_edit"></el-input>
										</span>
									</el-form-item>
									<el-form-item label="姓名">
										<span>
											<el-input v-model="userList.name" style="width: 240px;"
												class="user_edit"></el-input>
										</span>
									</el-form-item>
									<el-form-item label="性别">
										<span>{{ userList.sex == null ? "未知" : (userList.sex == 1 ? "男" : "女") }}</span>
									</el-form-item>
									<el-form-item label="电话号码">
										<span>{{ userList.phone }}</span>
									</el-form-item>
									<el-form-item label="邮箱"> <span>
											<el-input v-model="userList.email" style="width: 240px;"
												class="user_edit"></el-input>
										</span>
									</el-form-item>
									<el-form-item label="QQ号码"> <span>{{ userList.qq }}</span>
									</el-form-item>
									<el-form-item label="微信"> <span>{{ userList.wechat }}</span>
									</el-form-item>
									<el-form-item size="large">
										<el-button type="primary" @click="onSubmit" class="baocun">保存</el-button>
									</el-form-item>
								</el-form>
							</el-card>
						</el-tab-pane>
						<el-tab-pane label="更换手机号">
							<div class="tab-pane-k wechat-bing">
							</div>
						</el-tab-pane>
						<!--           <el-tab-pane label="绑定微信">
              <div class="tab-pane-k wechat-bing">
                <img src="../assets/wechat.png">
                <p>点击下方按钮进行绑定或者换绑微信</p>
                <el-popover placement="top" width="400" trigger="click">
                  <div id="qrcode" class="qrcode"></div>
                  <el-button @click="getQrcode()" slot="reference">点击绑定</el-button>
                </el-popover>
              </div>
            </el-tab-pane> -->
						<el-tab-pane label="修改密码">
							<div class="tab-pane-k edit-password">
								<el-form class="main" ref="form" :model="password" label-width="80px">
									<div class="title">修改密码</div>
									<el-form-item label="原密码：" lable-width="90px">
										<el-input v-model="password.original"></el-input>
									</el-form-item>
									<el-form-item label="新密码：" lable-width="90px">
										<el-input v-model="password.password"></el-input>
									</el-form-item>
									<el-form-item label="确认密码：" lable-width="90px">
										<el-input v-model="password.confirm"></el-input>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="editPassword">立即修改</el-button>
									</el-form-item>
								</el-form>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<!-- 底部链接 -->
		<Footer></Footer>
	</div>
</template>
<script>
	import Menu from '@/components/view/Menu'
	import Footer from '@/components/view/Footer'
	import Vue from "vue"
	export default {
		name: 'personedit',
		components: {
			Menu,
			Footer
		},
		data() {
			return {
				userList: {
					nickname: "",
					avatar_url: ""
				},
				password: {

				},
				tabPosition: 'left'
			}
		},
		created() {
			this.userInfo()
			this.getQrcode()
		},
		mounted() {
			// 注册监听框架传来的数据
			this.$nextTick(() => {
				// 在外部 Vue 的 window 上添加 postMessage 的监听，并且绑定处理函数 handleMessage
				window.addEventListener('message', this.wechatLoginReturn)
			});
		},
		methods: {
			// 监听微信扫码登陆返回
			wechatLoginReturn(event) {
				const x = event.data
				const data = JSON.parse(x)
				switch (data.cmd) {
					case 'ready-for-receiving': { //接受准备消息
						this.$message.success(data.message) // 判断手段是否成功
						break;
					}
				}
			},
			getQrcode() {
				let wxLoginClass = new WxLogin({
					self_redirect: true,
					id: "qrcode",
					appid: "wxe244bfaa61a3756b",
					scope: "snsapi_login",
					redirect_uri: encodeURIComponent('https://www.meikesheji.com/#/loginsuccess?type=2'),
				});
			},
			userInfo() {
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/userInfo', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					}
				}).then(res => {
					this.userList = res.data.data
				}).catch(err => {
					console.log(err)
				})
			},
			editPassword() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						if (this.password.password != this.password.confirm) {
							this.$message({
								message: '密码输入不一致',
								type: 'error'
							});
							return;
						}
						this.$axios({
							method: 'post', // 请求格式
							url: '/api/user/edit', // 请求路径
							headers: { // 设置请求头
								token: this.$cookieStore.getCookie('token')
							},
							data: {
								"old": this.password.original,
								"password": this.password.password
							}
						}).then(res => {
							if (res.data.code == 200) {
								this.$message({
									message: res.data.msg,
									type: 'success'
								});
							} else {
								this.$message.error(res.data.msg);
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			onSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.$axios({
							method: 'post', // 请求格式
							url: '/api/user/edit', // 请求路径
							headers: { // 设置请求头
								token: this.$cookieStore.getCookie('token')
							},
							data: {
								nickname: this.userList.nickname,
								name: this.userList.name
							}
						}).then(res => {
							if (res.data.code == 200) {
								this.$message({
									message: res.data.msg,
									type: 'success'
								});
							} else {
								this.$message.error(res.data.msg);
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			avrouSucess(res, file) {
				console.log(res.data.data.thumb);
				Vue.set(this.userInfo, this.userInfo.avatar_url, res.data.data.thumb)
				this.userInfo.avatar_url = res.data.data.thumb
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/user/edit', // 请求路径
					headers: { // 设置请求头
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						"avatar_url": res.data.data.thumb
					}
				}).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.userInfo()
					} else {
						this.$message.error(res.data.msg);
					}
				}).catch(err => {

				})
			}
		}
	}
</script>
<style scoped lang="scss">
	// 修改密码
	/deep/ .edit-password .el-input__inner {
		width: 250px;
		height: 40px;
	}

	/deep/ .el-form-item__label {
		padding: 0
	}

	/deep/ .edit-password .el-button--primary {
		width: 360px;
		font-size: 16px;
		padding: 15px 20px;
		background: #FABE00;
		border-radius: 25px;
		border: none;
		margin-left: -20px;
	}

	.edit-password .main {
		text-align: center;
		width: 360px;
		margin: 50px auto;
	}

	.edit-password .title {
		font-size: 24px !important;
		margin-bottom: 50px;
	}

	// 换绑微信
	.tab-pane-k {
		border: 1px solid #EBEEF5;
		padding: 30px;
		min-height: 600px;
	}

	.wechat-bing {
		font-size: 20px;
	}

	.wechat-bing p {
		margin: 20px 0
	}

	.wechat-bing img {
		width: 80px;
		margin: 100px 0 0px 0;
	}

	.qrcode {
		text-align: center;
		padding-top: 10px;
	}

	/deep/ .el-tabs--left .el-tabs__header.is-left {
		margin-right: 30px;
		background: #F5F8F8;
		padding: 10px 20px;
	}

	/deep/ .el-tabs--left .el-tabs__item.is-left {
		margin: 10px auto;
		height: 40px;
		line-height: 40px;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
	}

	/deep/ .is-active {
		background: #fabe00;
		color: #fff;
		margin: 10px auto;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border-radius: 10px;
	}

	.imgavbox {
		display: flex;
		border: 1px solid #F5F8F8;
		border-radius: 5px;
		align-items: center;
		border: 1px solid rgba($color: #b3abab, $alpha: 0.2);
		padding: 4px 15px;
		font-size: 13px;
	}

	.imgavbox .iconfont {
		font-size: 20px;
		margin-right: 7px;
	}

	.avtouimg {
		float: right;
		margin-left: 25px;
		margin-top: 24%;
		transform: translateY(-50%);
	}

	/deep/ .el-form-item {
		display: flex;
		align-items: center;
		font-size: 16px;
		margin-top: 30px;
	}

	/deep/ .el-form-item__content {
		text-align: left;
		margin-left: 20px !important;
		font-size: 16px;
	}

	/deep/ .el-card__body,
	.el-main {
		padding: 30px 40px;
	}

	.baocun {
		border: none;
		width: 164px;
		height: 49px;
		background: #FABE00;
		border-radius: 25px;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 500;
		color: #fff;
		margin-left: 138px;
		margin-top: 48px;
	}

	/deep/ .el-input__inner {
		background: #f7f7f7;
		height: 36px;
		border: none;
		font-size: 14px;
	}

	.user_edit {
		background: none;
		outline: none;
		border: none;
		width: 210px;
		height: 36px;
		background: #f7f7f7;
		border-radius: 8px;
	}

	.personal-center {
		width: 1200px;
		margin: 0 auto;
	}

	.personal-main {
		width: 1200px;
		margin: 20px auto 0;
		/* display: flex; */
		align-items: flex-start;
		justify-content: space-between;
	}

	.sticky {
		position: -webkit-sticky;
		position: sticky;
		top: 90px;
		z-index: 99;
		width: 100%;
		background: #fff;
		border-radius: 6px;
	}

	.personal-content_flex {
		display: flex;
	}

	.personal-main-content {
		width: 780px;
		min-height: 430px;
		margin: 0 20px;
	}

	.personal-main-right {
		width: 247px;
		position: -webkit-sticky;
		position: sticky;
		top: 90px;
		z-index: 99;
	}

	.userinfo-box {
		width: 247px;
		margin-bottom: 24px;
	}

	.content-box {
		background: #f5f8f8;
		border-radius: 8px;
		width: 100%;
		height: 82px;
		padding: 20px 2px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.content-box>div {
		width: 60px;
		text-align: center;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 400;
		color: #465156;
		line-height: 20px;
	}

	.content-box>div:nth-child(2) {
		margin-top: 2px;
		height: 20px;
	}

	.line {
		width: 1px;
		height: 20px;
		background-color: #e5e5e5;
	}

	.personal-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 60px;
		padding-bottom: 62px;
	}

	.empty-img {
		width: 240px;
		height: 126px;
	}

	.empty-txt {
		margin-top: 12px;
		width: -webkit-max-content;
		width: -moz-max-content;
		width: max-content;
		height: 20px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 600;
		color: #8d8e8e;
		line-height: 20px;
	}

	.personal-main-top {
		width: 1200px;
		height: 278px;
		background: url('~@/assets/personal/img01.png') 50% no-repeat;
		background-size: 1200px 278px;
		border-radius: 5px;
		overflow: hidden;
		margin: 33px 0 20px;
	}

	.personal-main-top>div {
		margin: 85px auto 0;
		text-align: center;
	}

	.personal-main-top>div img {
		// box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
		border: 5px solid #fff;
	}

	.head-image-box img {
		height: 100px;
		width: 100px;
		border-radius: 50%;
	}

	.editor-material-wrap {
		margin-top: -26px;
		cursor: pointer;
	}

	.editor-material {
		display: inline-block;
		width: 88px;
		height: 26px;
		background: #ffe500;
		border-radius: 15px;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 500;
		color: #18252c;
		line-height: 28px;
	}

	.editor-material-img {
		width: 80px;
		height: 80px;
		vertical-align: middle;
		border-radius: 50%;
		overflow: hidden;
		border: 5px solid #fff;
		box-shadow: 0px 0px 10px rgb(216, 210, 210);
	}

	.login-name {
		font-size: 20px;
		font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
		font-weight: 500;
		color: #fff;
		line-height: 28px;
		// text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
		margin-top: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/PersonalEdit.vue